module.exports = __webpack_public_path__ + "img/logob.bdb566f1.jpg";